import { render, staticRenderFns } from "./tipTemplate.vue?vue&type=template&id=8229498e&scoped=true"
import script from "./tipTemplate.vue?vue&type=script&lang=js"
export * from "./tipTemplate.vue?vue&type=script&lang=js"
import style0 from "./tipTemplate.vue?vue&type=style&index=0&id=8229498e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8229498e",
  null
  
)

export default component.exports